import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth.module'
import orders from './orders.module'
import vendors from './vendors.module'
import notes from './notes.module'
import roles from './roles.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    orders,
    vendors,
    notes,
    roles
  }
})
